(function () {
  const PERSONALIZER_HANDLES = [
    'a-personalized-scripture-book-written-over-your-child',
    'a-personalized-bedtime-prayer-book-written-over-your-child',
  ];

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function getCurrentPathWithSearch() {
    return window.location.pathname + window.location.search;
  }

  function normalize(str) {
    return String(str || '').trim().toLowerCase();
  }

  function isPersonalizerItem(item) {
    const props = item && item.properties ? item.properties : {};
    return Boolean(
      props._personalizer_book ||
      PERSONALIZER_HANDLES.includes(normalize(item && item.handle))
    );
  }

  function getProductHandle(item) {
    return (item && item.properties && item.properties._personalizer_book) || item.handle || PERSONALIZER_HANDLES[0];
  }

  function getQrAudioChoiceFromCartItem(item) {
    const props = item && item.properties ? item.properties : {};
    const visibleValue = String(props['QR Audio Add-on'] || '').trim().toLowerCase();
    const hiddenValue = String(props._qr_audio_addon || '').trim().toLowerCase();
    const variantTitle = String(item && item.variant_title || '').trim().toLowerCase();

    if (hiddenValue === 'yes' || visibleValue === 'yes' || /qr|audio/.test(variantTitle)) return 'yes';
    if (hiddenValue === 'no' || visibleValue === 'no') return 'no';

    return '';
  }

  function getExtraBookDiscountChoiceFromCartItem(item) {
    const props = item && item.properties ? item.properties : {};
    const hiddenValue = String(props._extra_book_discount || '').trim().toLowerCase();
    const variantTitle = String(item && item.variant_title || '').trim().toLowerCase();

    if (hiddenValue === 'yes' || /extra book|30% off|30 off/.test(variantTitle)) return 'yes';
    if (hiddenValue === 'no') return 'no';

    return '';
  }

  function buildEditUrl(item, source) {
    const params = new URLSearchParams();
    params.set('product', getProductHandle(item));
    if (item.properties && item.properties.Name) params.set('name', item.properties.Name);
    if (item.key) params.set('key', item.key);
    if (item.quantity) params.set('quantity', String(item.quantity));

    const qrAudioChoice = getQrAudioChoiceFromCartItem(item);
    if (qrAudioChoice) params.set('qr_audio', qrAudioChoice);

    const extraBookDiscountChoice = getExtraBookDiscountChoiceFromCartItem(item);
    if (extraBookDiscountChoice) params.set('extra_book_discount', extraBookDiscountChoice);

    params.set('return_to', source === 'drawer' ? getCurrentPathWithSearch() : '/cart');
    params.set('source', source);
    return `/pages/personalize-book?${params.toString()}`;
  }

  function getPersonalizedItems(cart) {
    return (cart.items || []).filter(isPersonalizerItem);
  }

  function getRowCandidates(root) {
    const selectors = [
      'tr',
      '.cart-item',
      '.cart__row',
      '.drawer__cart-item',
      '.ajax-cart__item',
      '.mini-cart__item',
      '.cart-drawer-item',
      '.line-item'
    ];
    const rows = new Set();
    selectors.forEach((selector) => {
      root.querySelectorAll(selector).forEach((el) => rows.add(el));
    });
    return Array.from(rows);
  }

  function rowText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function matchScore(row, item) {
    const text = rowText(row);
    let score = 0;
    const title = normalize(item.product_title);
    const name = normalize(item.properties && item.properties.Name);
    const handleWords = normalize((item.handle || '').replace(/-/g, ' '));

    if (title && text.includes(title)) score += 8;
    if (name && text.includes(name)) score += 5;
    if (handleWords && text.includes(handleWords.slice(0, 18))) score += 2;
    if (/hardcover|softcover/.test(text)) score += 1;
    return score;
  }

  function mapItemsToRows(root, items) {
    const rows = getRowCandidates(root);
    const unused = [...rows];
    const result = [];

    items.forEach((item) => {
      let bestIndex = -1;
      let bestScore = -1;
      unused.forEach((row, index) => {
        const score = matchScore(row, item);
        if (score > bestScore) {
          bestScore = score;
          bestIndex = index;
        }
      });
      if (bestIndex === -1 || bestScore < 1) return;
      const row = unused.splice(bestIndex, 1)[0];
      result.push([item, row]);
    });

    return result;
  }

  function removeDuplicateButtons(scope) {
    const links = Array.from(scope.querySelectorAll('.cart-personalizer-edit-link'));
    links.slice(1).forEach((el) => el.remove());
  }

  function scoreNameCandidate(el, expectedName) {
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!/^Name:/i.test(text)) return -1;

    let score = 0;
    if (expectedName && text.toLowerCase().includes(expectedName.toLowerCase())) score += 5;
    if (el.querySelector('.cart-personalizer-edit-link')) score -= 3;
    score -= el.querySelectorAll('*').length * 0.02;
    score -= text.length * 0.0005;
    return score;
  }

  function findBestNameLine(row, item) {
    const expectedName = String((item.properties && item.properties.Name) || '').trim();
    const candidates = Array.from(row.querySelectorAll('*')).filter((el) => /^\s*Name:/i.test((el.textContent || '').trim()));
    if (!candidates.length) return null;
    candidates.sort((a, b) => scoreNameCandidate(b, expectedName) - scoreNameCandidate(a, expectedName));
    return candidates[0] || null;
  }

  function findInsertionTarget(row) {
    const selectors = [
      '.cart-item__details',
      '.cart-drawer__item-info',
      '.drawer__cart-item-details',
      '.ajax-cart__item-details',
      '.mini-cart__item-info',
      '.line-item__content',
      '.cart-item__name',
      '.product-option',
      'dd',
      '.cart-item__meta'
    ];

    for (const selector of selectors) {
      const matches = row.querySelectorAll(selector);
      if (matches.length) return matches[matches.length - 1];
    }

    const titleLink = row.querySelector('a[href*="/products/"]');
    return titleLink || row.firstElementChild || row;
  }

  function createButton(item, source) {
    const button = document.createElement('a');
    button.className = 'cart-personalizer-edit-link';
    button.href = buildEditUrl(item, source);
    button.textContent = 'Personalize';
    button.setAttribute('aria-label', `Edit personalization for ${item.product_title || 'this book'}`);
    return button;
  }

  function decorateNameLine(nameLine, item, source) {
    if (!nameLine) return false;

    nameLine.classList.add('cart-personalizer-name-line');
    removeDuplicateButtons(nameLine);
    const existing = nameLine.querySelector('.cart-personalizer-edit-link');
    if (existing) {
      existing.href = buildEditUrl(item, source);
      existing.textContent = 'Personalize';
      return true;
    }

    const button = createButton(item, source);
    nameLine.appendChild(document.createTextNode(' '));
    nameLine.appendChild(button);
    return true;
  }

  function ensureStandaloneButton(row, item, source) {
    const target = findInsertionTarget(row);
    if (!target) return;

    let wrapper = row.querySelector('.cart-personalizer-inline-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'cart-personalizer-inline-wrapper';
      const tag = target.tagName;
      if (tag === 'DD' || tag === 'DT' || tag === 'SPAN' || tag === 'A') {
        target.insertAdjacentElement('afterend', wrapper);
      } else {
        target.appendChild(wrapper);
      }
    }

    let existing = wrapper.querySelector('.cart-personalizer-edit-link');
    if (existing) {
      existing.href = buildEditUrl(item, source);
      existing.textContent = 'Personalize';
      existing.setAttribute('aria-label', `Edit personalization for ${item.product_title || 'this book'}`);
      return;
    }

    wrapper.appendChild(createButton(item, source));
  }

  function resetInjectedUi() {
    // Intentionally kept as a no-op.
    // The UI injection below is idempotent, so we do not tear down and rebuild
    // links on every MutationObserver pass. That previous behavior caused
    // repeated DOM churn in cart/cart-drawer and could break clicks/remove actions.
  }

  function hideVisibleQrAudioPropertyLines(row) {
    if (!row) return;

    const candidates = Array.from(row.querySelectorAll('dd, dt, li, p, span, div, .product-option'));
    candidates.forEach((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();

      if (/^QR Audio Add-on\s*:/i.test(text) && text.length <= 60) {
        el.style.display = 'none';
        el.setAttribute('data-glh-hidden-qr-audio-property', 'true');
      }
    });
  }

  function hidePersonalizedQuantityControls(row, item) {
    if (!row || !item) return;

    // Quantity controls are removed in Liquid on the cart page.
    // Keep this function idempotent and only clean up old injected notes from earlier builds.
    row.querySelectorAll('.cart-personalizer-qty-note, [data-glh-personalized-qty-note]').forEach((el) => el.remove());
  }

  async function normalizePersonalizedCartQuantities(cart) {
    if (!cart || window.__glhPersonalizedQtyNormalized === '1') return;
    window.__glhPersonalizedQtyNormalized = '1';

    const items = getPersonalizedItems(cart).filter((item) => (Number(item.quantity) || 0) > 1);
    if (!items.length) return;

    try {
      for (const item of items) {
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 1
          })
        });
      }
      window.location.reload();
    } catch (error) {
      console.warn('Could not normalize personalized book quantity', error);
    }
  }

  function decorateRows(root, items, source) {
    mapItemsToRows(root, items).forEach(([item, row]) => {
      hideVisibleQrAudioPropertyLines(row);
      hidePersonalizedQuantityControls(row, item);

      const nameLine = findBestNameLine(row, item);
      const attachedToName = decorateNameLine(nameLine, item, source);
      if (!attachedToName) ensureStandaloneButton(row, item, source);
    });
  }

  async function mountCartPersonalizerLinks() {
    let cart;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      cart = await res.json();
    } catch (_error) {
      return;
    }

    normalizePersonalizedCartQuantities(cart);

    const personalizedItems = getPersonalizedItems(cart);
    resetInjectedUi();
    if (!personalizedItems.length) return;

    decorateRows(document, personalizedItems, 'page');

    const drawerRoots = Array.from(document.querySelectorAll('cart-drawer, .cart-drawer, .drawer__inner, .ajax-cart, .mini-cart')).filter(isVisible);
    drawerRoots.forEach((drawerRoot) => {
      decorateRows(drawerRoot, personalizedItems, 'drawer');
    });
  }

  function openDrawerFromQuery() {
    const url = new URL(window.location.href);
    if (url.searchParams.get('open_cart_drawer') !== '1') return;

    const candidates = [
      'button[aria-controls*="CartDrawer"]',
      'button[data-cart-drawer-open]',
      'button[data-drawer-open*="cart"]',
      '.header__icon--cart',
      '.cart-icon-bubble'
    ];

    for (const selector of candidates) {
      const trigger = document.querySelector(selector);
      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.click();
        break;
      }
    }

    url.searchParams.delete('open_cart_drawer');
    window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '') + url.hash);
  }

  document.addEventListener('DOMContentLoaded', function () {
    openDrawerFromQuery();
    mountCartPersonalizerLinks();

    let scheduled = false;
    const observer = new MutationObserver(function (mutations) {
      const hasRelevantMutation = mutations.some(function (mutation) {
        const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
        return nodes.some(function (node) {
          if (!(node instanceof Element)) return false;
          return Boolean(
            node.closest?.('cart-drawer, .cart-drawer, cart-items, .cart-items, #main-cart-items, form[action="/cart"]') ||
            node.querySelector?.('cart-drawer, .cart-drawer, cart-items, .cart-items, #main-cart-items, form[action="/cart"]')
          );
        });
      });

      if (!hasRelevantMutation || scheduled) return;
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        mountCartPersonalizerLinks();
      }, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();

(function () {
  const FONT_LINK_ID = 'glh-bedtime-style-test-fonts';
  const STYLE_ID = 'glh-bedtime-style-test-css';
  const PAGE_SIZE = 2400;

  const BODY_BROWN = 'rgb(78, 55, 28)';
  const DEDICATION_BLUE = 'rgb(8, 50, 82)';
  const COVER_WHITE = 'rgb(255, 255, 250)';

  // Mobile-only body-page lift. Keeps desktop placements untouched.
  const MOBILE_BODY_Y_OFFSET = -45;

  // Style test pass: only cover, page 1 and page 3 are overridden.
  // Other Bedtime Prayer pages fall back to the existing personalizer placements for now.
  const PLACEMENTS = {
    '01_cover_front': [
      { kind: 'cover', x: 1222, y: 955, size: 118, maxw: 990 }
    ],
    '02_page_01': [
      { kind: 'dedication', x: 1686, y: 717, size: 100, maxw: 700, qr: { x: 1705, y: 485, size: 93, maxw: 670 } }
    ],
    '03_page_02_03': [
      { kind: 'body', side: 'right', x: 1213, y: 752, size: 69, maxw: 600 },
      { kind: 'body', side: 'right', x: 1213, y: 1615, size: 69, maxw: 600 }
    ],
    '04_page_04_05': [
      { kind: 'body', side: 'left', x: 1137, y: 760, size: 69, maxw: 600 },
      { kind: 'body', side: 'left', x: 1137, y: 1481, size: 69, maxw: 600 }
    ],
    '05_page_06_07': [
      { kind: 'body', side: 'right', x: 1239, y: 687, size: 69, maxw: 600 },
      { kind: 'body', side: 'right', x: 1239, y: 1659, size: 69, maxw: 600 }
    ],
    '06_page_08_09': [
      { kind: 'body', side: 'left', x: 1140, y: 773, size: 69, maxw: 600 },
      { kind: 'body', side: 'left', x: 1140, y: 1408, size: 69, maxw: 600 }
    ],
    '07_page_10_11': [
      { kind: 'body', side: 'right', x: 1211, y: 928, size: 69, maxw: 600 },
      { kind: 'body', side: 'right', x: 1211, y: 1540, size: 69, maxw: 600 }
    ],
    '08_page_12_13': [
      { kind: 'body', side: 'left', x: 1140, y: 705, size: 69, maxw: 600 },
      { kind: 'body', side: 'left', x: 1140, y: 1627, size: 69, maxw: 600 }
    ],
    '09_page_14_15': [
      { kind: 'body', side: 'right', x: 1246, y: 632, size: 69, maxw: 600 },
      { kind: 'body', side: 'right', x: 1246, y: 1545, size: 69, maxw: 600 }
    ],
    '10_page_16_17': [
      { kind: 'body', side: 'left', x: 1189, y: 625, size: 69, maxw: 600 },
      { kind: 'body', side: 'left', x: 1189, y: 1514, size: 69, maxw: 600 }
    ],
    '11_page_18_19': [
      { kind: 'body', side: 'right', x: 1232, y: 595, size: 69, maxw: 600 },
      { kind: 'body', side: 'right', x: 1232, y: 1642, size: 69, maxw: 600 }
    ],
    '12_page_20_21': [
      { kind: 'body', side: 'left', x: 1105, y: 702, size: 69, maxw: 600 },
      { kind: 'body', side: 'left', x: 1105, y: 1562, size: 69, maxw: 600 }
    ],
    '13_page_22_23': [
      { kind: 'body', side: 'right', x: 1204, y: 598, size: 69, maxw: 600 },
      { kind: 'body', side: 'right', x: 1204, y: 1633, size: 69, maxw: 600 }
    ]
  };

  function ensureFontsAndStyles() {
    if (!document.getElementById(FONT_LINK_ID)) {
      const link = document.createElement('link');
      link.id = FONT_LINK_ID;
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700&family=Playfair+Display:ital,wght@1,700;1,900&display=swap';
      document.head.appendChild(link);
    }

    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `
        [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="cover"] {
          filter: drop-shadow(0 2px 1px rgba(15, 34, 52, 0.18));
        }

        [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="cover"] .book-personalizer-name__svg text {
          font-family: 'Cinzel', Georgia, serif !important;
          font-weight: 700 !important;
          font-size: 168px !important;
          letter-spacing: 0.012em !important;
          transform-box: fill-box !important;
          transform-origin: center center !important;
          transform: scaleX(0.88) !important;
          fill: ${COVER_WHITE} !important;
          stroke: none !important;
          paint-order: normal !important;
        }

        [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="cover"] .layer-1,
        [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="cover"] .layer-2,
        [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="cover"] .layer-3 {
          display: none !important;
        }

        [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="dedication"] {
          font-family: 'Playfair Display', Georgia, serif !important;
          font-style: italic !important;
          font-weight: 700 !important;
          letter-spacing: -0.02em !important;
          line-height: 0.9 !important;
          text-shadow: none !important;
          text-transform: none !important;
          -webkit-font-smoothing: antialiased !important;
          text-rendering: geometricPrecision !important;
        }

        [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="body"] {
          font-family: 'Playfair Display', Georgia, serif !important;
          font-style: italic !important;
          font-weight: 700 !important;
          letter-spacing: -0.022em !important;
          line-height: 0.9 !important;
          opacity: 0.86 !important;
          filter: none !important;
          text-shadow: 0 0 0.45px currentColor !important;
          text-transform: none !important;
          -webkit-font-smoothing: antialiased !important;
          text-rendering: geometricPrecision !important;
        }

        [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="body"] span {
          display: inline-block !important;
          transform: skewX(-1.5deg) !important;
          transform-origin: center center !important;
        }

        @media screen and (max-width: 749px) {
          [data-book-file-set="bedtime_prayer"] .book-personalizer-name[data-glh-bedtime-style-test="body"] {
            font-weight: 800 !important;
            letter-spacing: -0.028em !important;
            opacity: 1 !important;
            filter: none !important;
            text-shadow: 0 0 0.35px currentColor !important;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }

  function pct(value, basis) {
    return ((Number(value) || 0) / basis) * 100;
  }

  function getPageDisplayWidth(card, placement) {
    const spread = card.querySelector('.book-personalizer-page-spread');
    if (spread && placement.side) {
      const rect = spread.getBoundingClientRect();
      return rect.width > 0 ? rect.width / 2 : 0;
    }

    const image = card.querySelector('img');
    const rect = image ? image.getBoundingClientRect() : card.getBoundingClientRect();
    return rect.width || 0;
  }

  function getResolvedPlacement(card, placement) {
    if (!placement.qr) return placement;

    const image = card.querySelector('img');
    const src = image ? String(image.currentSrc || image.src || '') : '';
    return src.indexOf('bedtime_prayer_page_01_qr') !== -1 ? placement.qr : placement;
  }

  function isMobilePreview() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function clampPageValue(value) {
    return Math.max(0, Math.min(PAGE_SIZE, Number(value) || 0));
  }

  function positionElement(card, el, rawPlacement) {
    const placement = getResolvedPlacement(card, rawPlacement);
    const pageWidth = getPageDisplayWidth(card, placement);
    const isSpread = Boolean(placement.side);

    let xPercent;
    let widthPercent;

    if (isSpread) {
      const localX = pct(placement.x, PAGE_SIZE) * 0.5;
      xPercent = placement.side === 'left' ? localX : 50 + localX;
      widthPercent = pct(placement.maxw, PAGE_SIZE) * 0.5;
    } else {
      xPercent = pct(placement.x, PAGE_SIZE);
      widthPercent = pct(placement.maxw, PAGE_SIZE);
    }

    const effectiveY = placement.kind === 'body' && isMobilePreview()
      ? clampPageValue(placement.y + MOBILE_BODY_Y_OFFSET)
      : placement.y;

    const yPercent = pct(effectiveY, PAGE_SIZE);
    const fontPx = pageWidth ? ((placement.size / PAGE_SIZE) * pageWidth) : null;

    el.style.setProperty('--bp-x', `${xPercent.toFixed(3)}%`, 'important');
    el.style.setProperty('--bp-y', `${yPercent.toFixed(3)}%`, 'important');
    el.style.setProperty('--bp-width', `${widthPercent.toFixed(3)}%`, 'important');

    if (fontPx) {
      el.style.setProperty('--bp-size', `${fontPx.toFixed(2)}px`, 'important');
    }

    if (placement.kind === 'cover') {
      el.dataset.glhBedtimeStyleTest = 'cover';
      el.style.setProperty('--bp-fill', COVER_WHITE, 'important');
    } else if (placement.kind === 'dedication') {
      el.dataset.glhBedtimeStyleTest = 'dedication';
      el.style.setProperty('--bp-color', DEDICATION_BLUE, 'important');
      el.style.setProperty('--bp-weight', '700', 'important');
    } else {
      el.dataset.glhBedtimeStyleTest = 'body';
      el.style.setProperty('--bp-color', BODY_BROWN, 'important');
      el.style.setProperty('--bp-weight', '700', 'important');
    }

    el.style.transform = 'translate(-50%, -50%) scale(1)';
    el.style.transformOrigin = 'center center';
  }

  function applyBedtimeStyleTest() {
    const root = document.querySelector('[data-book-personalizer-root]');
    if (!root || root.dataset.bookFileSet !== 'bedtime_prayer') return;

    ensureFontsAndStyles();

    Object.keys(PLACEMENTS).forEach((pageKey) => {
      const card = root.querySelector(`[data-page-key="${pageKey}"]`);
      if (!card) return;

      const targets = Array.from(card.querySelectorAll('.book-personalizer-name'));
      const placements = PLACEMENTS[pageKey] || [];

      placements.forEach((placement, index) => {
        const el = targets[index];
        if (!el) return;
        positionElement(card, el, placement);
      });
    });
  }

  function scheduleApply() {
    window.requestAnimationFrame(() => {
      applyBedtimeStyleTest();
      window.setTimeout(applyBedtimeStyleTest, 60);
      window.setTimeout(applyBedtimeStyleTest, 180);
    });
  }

  function mountBedtimeStyleTest() {
    const root = document.querySelector('[data-book-personalizer-root]');
    if (!root || root.dataset.glhBedtimeStyleTest === '1') return;

    root.dataset.glhBedtimeStyleTest = '1';
    scheduleApply();

    const preview = root.querySelector('[data-book-preview]');
    if (preview && 'MutationObserver' in window) {
      const observer = new MutationObserver(scheduleApply);
      observer.observe(preview, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'src'] });
      root._glhBedtimeStyleTestObserver = observer;
    }

    const originalRender = root._bpRender;
    if (typeof originalRender === 'function') {
      root._bpRender = function () {
        const result = originalRender.apply(this, arguments);
        scheduleApply();
        return result;
      };
    }

    const originalScheduleRender = root._bpScheduleRender;
    if (typeof originalScheduleRender === 'function') {
      root._bpScheduleRender = function () {
        const result = originalScheduleRender.apply(this, arguments);
        scheduleApply();
        return result;
      };
    }

    window.addEventListener('resize', scheduleApply);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleApply).catch(() => {});
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.setTimeout(mountBedtimeStyleTest, 0);
    window.setTimeout(mountBedtimeStyleTest, 120);
    window.setTimeout(scheduleApply, 350);
  });
})();
